import React from 'react';

/** Lazy ClientComputedCalendar (not wrapped in a suspense to use the parent widget loading fallback) */

export const ClientComputedCalendar = React.lazy(
    () =>
        import(
            /* webpackChunkName: 'widget-calendar' */
            './ClientComputedCalendar'
        ),
);
